export default __webpack_public_path__ + "static/media/Photo 9 - BR - ouverture sud et feuilles caduques.7f2befa3.jpg";